import { Card, H5, FormGroup, InputGroup } from "@blueprintjs/core";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { InstructionTo, ListState } from "src/models/TemplateCreationList";

type Props = {
    lists: ListState;
    setLists: React.Dispatch<React.SetStateAction<ListState>>;
    list: InstructionTo[];
    setList: (listName: keyof ListState, newList: InstructionTo[]) => void;
};
export default function InputHardcodeSet({ lists, setLists, list, setList }: Props) {
    return (
        <Card className="instructions-card">
            <H5>Hardcode</H5>
            <Droppable droppableId={`hardcode`}>
                {provided => (
                    <ul style={{ listStyle: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                        {lists.hardcode.map((p, index) => {
                            return (
                                <Draggable
                                    key={`hardcode${p.original}_${index}`}
                                    draggableId={`hardcode${p.original}_${index}`}
                                    index={index}
                                >
                                    {provided => (
                                        <li
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            ref={provided.innerRef}
                                        >
                                            <FormGroup className="hardcode" label={p.original} labelFor="text-input">
                                                <InputGroup
                                                    placeholder={`Enter ${p.original}...`}
                                                    type="text"
                                                    value={p.value ? p.value : ""}
                                                    small
                                                    onChange={e => {
                                                        const newList = [...list];
                                                        newList[index].value = e.currentTarget.value;
                                                        setList("hardcode", newList);
                                                    }}
                                                />
                                            </FormGroup>
                                        </li>
                                    )}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </Card>
    );
}
